<script lang="ts">
  import HeroImage from "../assets/images/hero-image.png";
  import HeroMobile from "../assets/images/hero-mobile.png";
</script>

<svelte:head>
  <title>Error Duplicate</title>
</svelte:head>

<main>
  <!-- Hero Home -->
  <section class="px-3.5 md:px-7">
    <!-- image desktop -->
    <div class="md:block hidden relative z-0">
      <img src={HeroImage} alt="hero" class="h-[553px] w-full object-cover" />
      <p
        class="flex items-center gap-1.5 text-xs font-semibold text-white absolute left-3 bottom-3"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="8"
          height="10"
          viewBox="0 0 8 10"
          fill="none"
        >
          <path
            d="M3.61111 0C1.61669 0 0 1.59875 0 3.57104C0 6.10704 3.61111 10 3.61111 10C3.61111 10 7.22222 6.10568 7.22222 3.57104C7.22222 1.59875 5.60553 0 3.61111 0ZM3.61111 5.18202C2.71142 5.18202 1.98206 4.46074 1.98206 3.57104C1.98206 2.68134 2.71142 1.96007 3.61111 1.96007C4.5108 1.96007 5.24016 2.68134 5.24016 3.57104C5.24016 4.46074 4.5108 5.18202 3.61111 5.18202Z"
            fill="white"
          />
        </svg>
        Signia by Hilton Atlanta Georgia World Congress Center
      </p>
    </div>
    <!-- image mobile -->
    <div class="md:hidden block">
      <img src={HeroMobile} alt="hero mobile" class="w-full object-cover" />
    </div>
  </section>
  <!-- END hero home -->

  <!-- Intro text -->
  <section class="px-3.5 md:px-7">
    <div class="bg-primary-off-white py-7 md:py-20 w-full">
      <div class="container-center">
        <div class="text-center">
          <h2
            class="font-hilton-serif text-4xl text-black font-normal leading-120 -tracking-0.72 mb-5"
          >
            Oops!
          </h2>
          <p class="text-lg font-medium leading-120 font-hilton-sans">
            We detected you've already submitted an entry to this sweepstakes!
            If you have questions message
            <a href="#" target="_blank" class="underline text-primary-blue">
              @gofoojihelp on Instagram!</a
            >
          </p>
        </div>
      </div>
    </div>
  </section>
  <!-- END intro text -->
</main>
